"use client";
import { styled } from "@mui/material/styles";
import { SpaceLg, SpaceInsetMd } from "@nxt-costco-com/forge-design-tokens";
import { CostcoBox } from "../../../Util/CostcoBox.js";
const StyledHeader = styled(CostcoBox)(
  ({ backgroundColor }) => ({
    background: backgroundColor,
    borderRadius: "10px",
    display: "flex",
    alignItems: "flex-start",
    flexWrap: "wrap",
    padding: SpaceInsetMd,
    rowGap: SpaceLg
  })
);
const commonStyles = {
  height: "auto",
  verticalAlign: "bottom",
  width: "100%"
};
const imageWrapperStyle = {
  ...commonStyles,
  overflow: "hidden"
};
const imageStyle = {
  ...commonStyles,
  display: "block"
};
const mobileImageStyle = {
  ...commonStyles,
  display: "none"
};
export {
  StyledHeader,
  commonStyles,
  imageStyle,
  imageWrapperStyle,
  mobileImageStyle
};
